__turbopack_context__.v({
  "logo": "Logo-module__gDhVqG__logo",
});
